/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable new-cap */

import React, { useRef, useEffect } from 'react';
import { Footer, Header } from 'layout';
import { I18nextProvider } from 'react-i18next';
import { theme, GlobalStyle } from 'styles';
import { ThemeProvider } from 'styled-components';
import { Landing } from 'pages';

import useScript from 'hooks/useScript';

import i18n from './i18n/i18n';

function App(props) {
  useScript('https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js', true, () => {
    if (!Kakao.isInitialized()) {
      Kakao.init(process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY);
    }
  });


  const sectionRefs = useRef({});

  useEffect(() => {
    const { history } = window;
    history.scrollRestoration = 'manual';
  }, []);

  // issue#12326: implement scroll to request
  // 콘텐츠 페이지(/library, /weekly)에서 /#request 처럼 들어오면 해당 섹션으로 이동
  useEffect(() => {
    const name = decodeURIComponent((window.location.hash || '').slice(1));
    if (!name) return undefined;
    const timer = setTimeout(() => {
      const el = sectionRefs.current[name];
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Header sectionRefs={sectionRefs} />
        <Landing sectionRefs={sectionRefs} />
        <Footer sectionRefs={sectionRefs} />
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
